import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { ApiMode } from '@vsolv/core/multi-tenant/domain';
import { API_MODE } from '@vsolv/core/multi-tenant/web';

export interface EnvironmentConfig {
  apiBaseUrl?: string;
}

export const ENVIRONMENT_CONFIG = new InjectionToken<EnvironmentConfig>('ENVIRONMENT_CONFIG');

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  constructor(
    @Optional() @Inject(ENVIRONMENT_CONFIG) private config?: EnvironmentConfig,
    @Optional() @Inject(API_MODE) private apiMode?: ApiMode
  ) {}

  get isSandbox(): boolean {
    // The app's build mode is authoritative, e.g. locally where both modes are served from localhost
    if (this.apiMode) return this.apiMode === ApiMode.SANDBOX;

    // Check if the API base URL indicates sandbox environment
    const apiIsSandbox = !!this.config?.apiBaseUrl && this.config.apiBaseUrl.includes('sandbox');

    // Check if the hostname indicates sandbox environment (production URLs)
    const hostname = window?.location?.hostname || '';
    const hostnameIsSandbox = hostname.includes('sandbox');

    return apiIsSandbox || hostnameIsSandbox;
  }
}
